/* eslint react/jsx-key: off */
import React from 'react';
import {
    Create,
    FormTab,
    SaveButton,
    TabbedForm,
    TextInput,
    SelectInput,
    AutocompleteInput,
    ReferenceInput,
    DateInput,
    LongTextInput,
    NumberInput,
    FileInput,
    FileField,
    ImageInput,
    ImageField,
    Toolbar,
    required,
} from 'react-admin';

const StockOutRequestEditToolbar = ({ permissions, ...props }) => (
    <Toolbar {...props}>
        <SaveButton
            label='resources.actions.save_and_show'
            redirect="show"
            submitOnEnter={true}
        />
    </Toolbar>
);

const getAccountInfo = (record) => {
    if(record.name) {
        return record.code + " " + record.name
    } else {
        return record.code
    }
}

const StockOutRequestCreate = function({ permissions, ...props }) {
 const urlParams = new URLSearchParams(props.location.search);
 const productId = urlParams.get('product_id') ? parseInt(urlParams.get('product_id')) : '';
 const userId = JSON.parse(localStorage.getItem('lbtoken')).value.userId;

 return (
    <Create {...props}>
        <TabbedForm toolbar={<StockOutRequestEditToolbar permissions={permissions} />}>
            <FormTab label="resources.stockoutrequests.form.summary" path="">
                <ReferenceInput 
                    source="productId" 
                    label="resources.stockoutrequests.fields.product" 
                    reference="products" 
                    perPage={100} 
                    validate={required()} 
                    defaultValue={productId}
                >
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <NumberInput
                    source="qty"
                    defaultValue=""
                    validate={required()}
                    autoComplete="off"
                />
                <SelectInput source="warehouse" choices={[
                    { id: 'rs', name: 'RS' },
                ]} defaultValue="rs" validate={required()} />
                <DateInput
                    source="stockOutDate"
                    defaultValue={new Date()}
                />
                <TextInput multiline 
                    source="shipfrom"
                />
                <TextInput  multiline 
                    source="shipto"
                />
                <SelectInput source="shippingCompany" choices={[
                    { id: 'Fedex', name: 'Fedex' },
                    { id: 'UPS', name: 'UPS' },
                    { id: 'USPS', name: 'USPS' },
                ]} defaultValue="UPS" />
                <FileInput source="boxLabel" multiple>
                    <FileField source="src" title="title" />
                </FileInput>
                <FileInput source="skulist">
                    <FileField source="src" title="title" />
                </FileInput>
                <ImageInput source="innerPage" >
                    <ImageField source="src" title="title" />
                </ImageInput>
                <ImageInput source="images" multiple>
                    <ImageField source="src" title="title" />
                </ImageInput>
                <TextInput
                    source="barcode"
                    autoComplete="off"
                />
                <SelectInput source="speed" allowEmpty emptyValue="" choices={[
                    { id: 'same_day', name: 'resources.stockoutrequests.speed.same_day' },
                    { id: 'urgent', name: 'resources.stockoutrequests.speed.urgent' },
                    { id: 'normal', name: 'resources.stockoutrequests.speed.normal' },
                ]} />
                <DateInput
                    source="stockOutDeadline"
                />
                <SelectInput source="status" choices={[
                    { id: 'stocking_out', name: 'resources.stockoutrequests.tab.stocking_out' },
                    { id: 'handling', name: 'resources.stockoutrequests.tab.handling' },
                    { id: 'stocked_out', name: 'resources.stockoutrequests.tab.stocked_out' },
                    { id: 'cancelled', name: 'resources.stockoutrequests.tab.cancelled' },
                ]} defaultValue="stocking_out" validate={required()} />
                <ReferenceInput source="appUserId" reference="appusers" label="resources.stockoutrequests.fields.user" validate={required()} defaultValue={userId}>
                    <SelectInput optionText="username" />
                </ReferenceInput>
                <ReferenceInput source="accountId" reference="accounts" label="resources.stockoutrequests.fields.account" perPage={100} filterToQuery={searchText => ({code: {"like": `%${searchText}%`, "options": "i"}})} filter={{"status": "active"}} sort={{ field: 'code', order: 'ASC' }}>
                    <AutocompleteInput optionText={getAccountInfo} />
                </ReferenceInput>
                <SelectInput source="country" validate={required()} choices={[
                    { id: '', name: '' },
                    { id: 'US', name: 'US' },
                    { id: 'CA', name: 'CA' },
                    { id: 'UK', name: 'UK' },
                    { id: 'DE', name: 'DE' },
                    { id: 'FR', name: 'FR' },
                ]} defaultValue="US" />
                <LongTextInput
                    source="note"
                />
            </FormTab>

        </TabbedForm>
    </Create>
)
};

export default StockOutRequestCreate;
